import { Component, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { delay, finalize, skip, startWith, tap } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { LoaderStateModel } from '@models/loader-state.model';
import {UserGuideService} from "@services/user-guide.service";

const loaderSubject = new Subject<LoaderStateModel>();
const loaderState = loaderSubject.asObservable();

/**
 * show spinner
 */
export const showSpinner = () => loaderSubject.next(<LoaderStateModel>{show: true});

/**
 * hide spinner
 */
export const hideSpinner = () => loaderSubject.next(<LoaderStateModel>{show: false});

/**
 * this function is created for usage within .pipe before .subscribe
 * it will show spinner before request & hide it in any case of response
 * (success, error, cancellation)
 * preferable to use it at first place inside of .pipe()
 * @return {<T>(source: Observable<T>) => Observable<any>}
 */
export const useSpinner = (hide?: boolean) => <T>(source: Observable<T>) => source.pipe(
    startWith((<any>'🖖')),
    tap(e => e === '🖖' && (hide ? hideSpinner() : showSpinner())),
    skip(1),
    finalize(() => hideSpinner())
);

@Component({
    selector: 'app-ledger-sync-spinner',
    templateUrl: 'spinner.html',
    styleUrls: ['spinner.scss'],
    standalone: true,
    imports: [CommonModule, TranslateModule]
})
export class LedgerSyncSpinner implements OnInit {
    show: boolean;

    trueStates: number = 0;
    falseStates: number = 0;

    constructor(
        private userGuideService: UserGuideService,
    ) {
    }

    ngOnInit() {
        loaderState
            .pipe(delay(100))
            .subscribe(({show}: LoaderStateModel) => {
                if (this.userGuideService.currentGuide) {
                    // no spinner while guide is active, because it makes bad ux
                    this.show = false;
                    this.trueStates = this.falseStates = 0;
                    return;
                }
                show ? this.trueStates++ : this.falseStates++;
                if (this.trueStates <= this.falseStates) this.trueStates = this.falseStates = 0;
                this.show = this.trueStates > this.falseStates;
            });
    }
}
